



































































import { Component, Vue, Watch } from "vue-property-decorator";
import store from "@/vuex";
import Goback from "@/views/frame/GoBack.vue";


@Component({
  components: { Goback },
})
export default class Footer extends Vue {
  toNd() {
    window.open("http://www.jfry.cn/")
  }

  toRy() {
    window.open("https://renyi.jfry.cn/")
  }
  jump(path) {
    store.commit('SET_LOCAL_PATH', path);
    this.$router.push(`/${path}`);
  }
  beianNumber: number = 6;

  mounted() {
    if (window.location.origin.indexOf('vip56') > -1) {
      this.beianNumber = 2;
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/frame/Footer.vue